// import React, { useMemo, useState, useEffect, useRef } from "react";
// import "./orderForm.css";
// import {
//   FiChevronRight,
//   FiX,
//   FiCheck,
//   FiSearch,
//   FiFilter,
//   FiTrash2,
//   FiLoader,
//   FiMapPin,
//   FiEdit3,
//   FiPlus,
// } from "react-icons/fi";
// import { 
//   STATE_DISTRICTS, 
//   DISTRICT_TALUKS, 
//   TALUK_PANCHAYATS 
// } from "../Customers/customerLocationData";

// const API_BASE = process.env.REACT_APP_EP || "http://localhost:5000";

// const inrFormatter = new Intl.NumberFormat("en-IN", {
//   style: "currency",
//   currency: "INR",
//   maximumFractionDigits: 2,
// });
// const formatINR = (value) => inrFormatter.format(value ?? 0);

// // Map items from various sources (API, initial order, etc.)
// const mapInitialItems = (items = []) => {
//   if (!items || items.length === 0) return [];
  
//   return items.map((item, index) => ({
//     lineId: item.lineId || `${item.sku || item.id || "line"}-${index}-${Math.random().toString(36).slice(2, 7)}`,
//     productId: item.productId || item.product_id || item.id,
//     name: item.name || item.product_name || item.productName || "",
//     sku: item.sku || "",
//     price: Number(item.price || item.unit_price || item.unitPrice || item.basePrice || 0),
//     qty: Number(item.qty || item.quantity || 1),
//     image: item.image || item.image_url || item.imageUrl || null,
//   }));
// };

// const OrderForm = ({
//   initialOrder,
//   preSelectedPanchayat,
//   onCancel,
//   onSave,
//   loading: parentLoading,
//   error: parentError,
// }) => {
//   // Refs for search inputs
//   const customerInputRef = useRef(null);
//   const productInputRef = useRef(null);

//   // Check if we're in edit mode
//   const isEditMode = Boolean(initialOrder?.id);

//   // Customer/Panchayat state
//   const [selectedCustomer, setSelectedCustomer] = useState(null);
//   const [customerQuery, setCustomerQuery] = useState("");
//   const [showCustomerSuggestions, setShowCustomerSuggestions] = useState(false);
  
//   // Filter states for panchayat
//   const [districtFilter, setDistrictFilter] = useState("all");
//   const [talukFilter, setTalukFilter] = useState("all");
//   const [showPanchayatFilters, setShowPanchayatFilters] = useState(false);

//   // Product state
//   const [products, setProducts] = useState([]);
//   const [productQuery, setProductQuery] = useState("");
//   const [showProductSuggestions, setShowProductSuggestions] = useState(false);
//   const [loadingProducts, setLoadingProducts] = useState(false);

//   // Items and form state
//   const [items, setItems] = useState([]);
//   const [error, setError] = useState("");
//   const [saving, setSaving] = useState(false);
//   const [isInitialized, setIsInitialized] = useState(false);

//   // Generate all panchayats from location data
//   const allPanchayats = useMemo(() => {
//     let panchayatList = [];
//     let idCounter = 1;

//     const districts = STATE_DISTRICTS["Karnataka"] || [];
//     districts.forEach(district => {
//       const taluks = DISTRICT_TALUKS[district] || [];
//       taluks.forEach(taluk => {
//         const panchayats = TALUK_PANCHAYATS[taluk] || [];
//         panchayats.forEach(name => {
//           panchayatList.push({
//             id: idCounter++,
//             name: name,
//             taluk: taluk,
//             district: district,
//             phone: "",
//           });
//         });
//       });
//     });

//     return panchayatList;
//   }, []);

//   // Generate district options
//   const districtOptions = useMemo(() => {
//     const districts = STATE_DISTRICTS["Karnataka"] || [];
//     return [
//       { value: "all", label: "All Districts" },
//       ...districts.map(district => ({ value: district, label: district }))
//     ];
//   }, []);

//   // Generate taluk options based on selected district
//   const talukOptions = useMemo(() => {
//     if (districtFilter === "all") {
//       const allTaluks = new Set();
//       const districts = STATE_DISTRICTS["Karnataka"] || [];
//       districts.forEach(district => {
//         const taluks = DISTRICT_TALUKS[district] || [];
//         taluks.forEach(taluk => allTaluks.add(taluk));
//       });
//       const sortedTaluks = Array.from(allTaluks).sort();
//       return [
//         { value: "all", label: "All Taluks" },
//         ...sortedTaluks.map(taluk => ({ value: taluk, label: taluk }))
//       ];
//     } else {
//       const taluks = DISTRICT_TALUKS[districtFilter] || [];
//       return [
//         { value: "all", label: "All Taluks" },
//         ...taluks.map(taluk => ({ value: taluk, label: taluk }))
//       ];
//     }
//   }, [districtFilter]);

//   // Reset taluk filter when district changes
//   useEffect(() => {
//     setTalukFilter("all");
//   }, [districtFilter]);

//   // Initialize form with existing order data or pre-selected panchayat
//   useEffect(() => {
//     if (isInitialized) return;

//     console.log("Initializing OrderForm with:", { initialOrder, preSelectedPanchayat, isEditMode });

//     // EDIT MODE: Load existing order data
//     if (isEditMode && initialOrder) {
//       console.log("Loading existing order for editing:", initialOrder);

//       // Load items from the order
//       if (initialOrder.items && initialOrder.items.length > 0) {
//         const mappedItems = mapInitialItems(initialOrder.items);
//         console.log("Mapped items for editing:", mappedItems);
//         setItems(mappedItems);
//       }

//       // Load customer/panchayat info
//       if (initialOrder.customer || initialOrder.panchayat) {
//         const customerData = initialOrder.customer || initialOrder.panchayat;
        
//         // Try to find matching panchayat in allPanchayats
//         const panchayatName = customerData.name || initialOrder.panchayat?.name;
//         const panchayatTaluk = customerData.taluk || initialOrder.panchayat?.taluk || initialOrder.shippingAddress?.taluk;
//         const panchayatDistrict = customerData.district || initialOrder.panchayat?.district || initialOrder.shippingAddress?.district;

//         const matchingPanchayat = allPanchayats.find(
//           (p) => 
//             p.name === panchayatName && 
//             (p.taluk === panchayatTaluk || !panchayatTaluk) && 
//             (p.district === panchayatDistrict || !panchayatDistrict)
//         );

//         if (matchingPanchayat) {
//           setSelectedCustomer(matchingPanchayat);
//           setCustomerQuery(matchingPanchayat.name);
//           setDistrictFilter(matchingPanchayat.district);
//           setTimeout(() => setTalukFilter(matchingPanchayat.taluk), 0);
//         } else {
//           // Create customer from order data
//           const customer = {
//             id: customerData.id,
//             name: panchayatName || "Unknown",
//             email: customerData.email || "",
//             phone: customerData.phone || "",
//             taluk: panchayatTaluk || "",
//             district: panchayatDistrict || "",
//           };
//           setSelectedCustomer(customer);
//           setCustomerQuery(customer.name);
//           if (panchayatDistrict) setDistrictFilter(panchayatDistrict);
//           if (panchayatTaluk) setTimeout(() => setTalukFilter(panchayatTaluk), 0);
//         }
//       }

//       setIsInitialized(true);
//       return;
//     }

//     // NEW ORDER: Check for pre-selected panchayat
//     let panchayatToSelect = preSelectedPanchayat;
    
//     if (!panchayatToSelect) {
//       const storedPanchayat = sessionStorage.getItem("selectedPanchayat");
//       if (storedPanchayat) {
//         try {
//           panchayatToSelect = JSON.parse(storedPanchayat);
//           sessionStorage.removeItem("selectedPanchayat");
//           sessionStorage.removeItem("orderAction");
//         } catch (e) {
//           console.error("Error parsing stored panchayat:", e);
//         }
//       }
//     }

//     if (panchayatToSelect) {
//       const matchingPanchayat = allPanchayats.find(
//         (p) => 
//           p.name === panchayatToSelect.name && 
//           p.taluk === panchayatToSelect.taluk && 
//           p.district === panchayatToSelect.district
//       );

//       if (matchingPanchayat) {
//         setSelectedCustomer(matchingPanchayat);
//         setCustomerQuery(matchingPanchayat.name);
//         setDistrictFilter(matchingPanchayat.district);
//         setTimeout(() => setTalukFilter(matchingPanchayat.taluk), 0);
//       } else {
//         const newPanchayat = {
//           id: Date.now(),
//           name: panchayatToSelect.name,
//           taluk: panchayatToSelect.taluk || "",
//           district: panchayatToSelect.district || "",
//           email: "",
//           phone: "",
//         };
//         setSelectedCustomer(newPanchayat);
//         setCustomerQuery(newPanchayat.name);
//         if (panchayatToSelect.district) setDistrictFilter(panchayatToSelect.district);
//         if (panchayatToSelect.taluk) setTimeout(() => setTalukFilter(panchayatToSelect.taluk), 0);
//       }
//     }

//     setIsInitialized(true);
//   }, [initialOrder, preSelectedPanchayat, allPanchayats, isEditMode, isInitialized]);

//   // Filter panchayats based on search query and filters
//   const customerSuggestions = useMemo(() => {
//     let filtered = allPanchayats;

//     if (districtFilter !== "all") {
//       filtered = filtered.filter(p => p.district === districtFilter);
//     }

//     if (talukFilter !== "all") {
//       filtered = filtered.filter(p => p.taluk === talukFilter);
//     }

//     if (customerQuery) {
//       const query = customerQuery.toLowerCase();
//       filtered = filtered.filter(
//         (p) =>
//           p.name.toLowerCase().includes(query) ||
//           p.taluk.toLowerCase().includes(query) ||
//           p.district.toLowerCase().includes(query)
//       );
//     }

//     return filtered.slice(0, 50);
//   }, [allPanchayats, customerQuery, districtFilter, talukFilter]);

//   // Fetch products
//   const fetchProducts = async (search = "") => {
//     setLoadingProducts(true);
//     try {
//       const params = search
//         ? `?search=${encodeURIComponent(search)}`
//         : "?limit=20";
//       const response = await fetch(`${API_BASE}/api/products${params}`, {
//         method: "GET",
//         headers: { "Content-Type": "application/json" },
//       });

//       if (!response.ok) throw new Error("Failed to fetch products");

//       const data = await response.json();
//       const productsList = data.data || data.products || [];

//       const transformedProducts = productsList.map((p) => ({
//         id: p.sku || p.id,
//         sku: p.sku,
//         name: p.product_name || p.name || "",
//         price: Number(p.base_price || p.price || 0),
//         stock: p.quantity || p.stock_quantity || 0,
//         description: p.description || "",
//         image: p.image_url || p.image || null,
//       }));

//       setProducts(transformedProducts);
//     } catch (err) {
//       console.error("Error fetching products:", err);
//     } finally {
//       setLoadingProducts(false);
//     }
//   };

//   // Fetch products on mount
//   useEffect(() => {
//     fetchProducts();
//   }, []);

//   // Live search for products
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       if (productQuery) {
//         fetchProducts(productQuery);
//         setShowProductSuggestions(true);
//       }
//     }, 400);

//     return () => clearTimeout(timer);
//   }, [productQuery]);

//   const productSuggestions = products;

//   const grandTotal = useMemo(
//     () => items.reduce((sum, item) => sum + item.price * item.qty, 0),
//     [items]
//   );

//   // Handlers
//   const handleCustomerKeyDown = (e) => {
//     if (e.key === "Enter") e.preventDefault();
//     if (e.key === "Escape") setShowCustomerSuggestions(false);
//   };

//   const handleProductKeyDown = (e) => {
//     if (e.key === "Enter") {
//       e.preventDefault();
//       if (productQuery) fetchProducts(productQuery);
//     }
//     if (e.key === "Escape") setShowProductSuggestions(false);
//   };

//   const handleCustomerBlur = (e) => {
//     const wrapper = e.currentTarget.closest(".order-search-wrapper");
//     if (wrapper && wrapper.contains(e.relatedTarget)) return;
//     setTimeout(() => setShowCustomerSuggestions(false), 200);
//   };

//   const handleProductBlur = (e) => {
//     const wrapper = e.currentTarget.closest(".order-search-wrapper");
//     if (wrapper && wrapper.contains(e.relatedTarget)) return;
//     setTimeout(() => setShowProductSuggestions(false), 200);
//   };

//   const handleSelectCustomer = (customer) => {
//     setSelectedCustomer(customer);
//     setCustomerQuery(customer.name);
//     setShowCustomerSuggestions(false);
//     setShowPanchayatFilters(false);
//   };

//   const handleSelectProduct = (product) => {
//     // Check if product already exists in items
//     const existingIndex = items.findIndex(item => item.sku === product.sku);
    
//     if (existingIndex >= 0) {
//       // Increase quantity if product already exists
//       setItems(prev => prev.map((item, index) => 
//         index === existingIndex 
//           ? { ...item, qty: item.qty + 1 }
//           : item
//       ));
//     } else {
//       // Add new product
//       setItems((prev) => [
//         ...prev,
//         {
//           lineId: `${product.id}-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
//           productId: product.id,
//           name: product.name,
//           sku: product.sku,
//           price: product.price,
//           qty: 1,
//           image: product.image,
//         },
//       ]);
//     }
    
//     setProductQuery("");
//     setShowProductSuggestions(false);
//     setTimeout(() => productInputRef.current?.focus(), 0);
//   };

//   const handleClearCustomer = () => {
//     setSelectedCustomer(null);
//     setCustomerQuery("");
//     setDistrictFilter("all");
//     setTalukFilter("all");
//     setShowCustomerSuggestions(false);
//     setTimeout(() => customerInputRef.current?.focus(), 0);
//   };

//   const handleClearPanchayatFilters = () => {
//     setDistrictFilter("all");
//     setTalukFilter("all");
//   };

//   const handleChangeQty = (lineId, raw) => {
//     const value = Number(raw);
//     const qty = Number.isFinite(value) && value > 0 ? value : 1;
//     setItems((prev) =>
//       prev.map((item) => (item.lineId === lineId ? { ...item, qty } : item))
//     );
//   };

//   const handleRemoveItem = (lineId) => {
//     setItems((prev) => prev.filter((item) => item.lineId !== lineId));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!selectedCustomer) {
//       setError("Please select a panchayat.");
//       return;
//     }
//     if (!items.length) {
//       setError("Please add at least one product.");
//       return;
//     }

//     setError("");
//     setSaving(true);

//     try {
//       const itemsForSave = items.map(({ lineId, ...rest }) => ({
//         sku: rest.sku,
//         quantity: rest.qty,
//         unit_price: rest.price,
//         product_id: rest.productId,
//         name: rest.name,
//       }));

//       const orderData = {
//         id: initialOrder?.id || null,
//         panchayat_name: selectedCustomer.name,
//         panchayat_taluk: selectedCustomer.taluk,
//         panchayat_district: selectedCustomer.district,
//         panchayat_state: 'Karnataka',
//         customer_name: selectedCustomer.name,
//         customer_taluk: selectedCustomer.taluk,
//         customer_district: selectedCustomer.district,
//         customer: selectedCustomer,
//         panchayat: {
//           name: selectedCustomer.name,
//           taluk: selectedCustomer.taluk,
//           district: selectedCustomer.district,
//         },
//         items: itemsForSave,
//         total_amount: grandTotal,
//         shipping_address: {
//           panchayat: selectedCustomer.name,
//           taluk: selectedCustomer.taluk,
//           district: selectedCustomer.district,
//           state: 'Karnataka'
//         }
//       };

//       console.log("Submitting order:", orderData);
//       await onSave(orderData);
//     } catch (err) {
//       setError(err.message || "Failed to save order");
//     } finally {
//       setSaving(false);
//     }
//   };

//   const isLoading = saving || parentLoading;
//   const displayError = error || parentError;

//   const hasActivePanchayatFilters = districtFilter !== "all" || talukFilter !== "all";
//   const activePanchayatFilterCount = [
//     districtFilter !== "all",
//     talukFilter !== "all"
//   ].filter(Boolean).length;

//   return (
//     <div className="orders-page order-form-page">
//       {/* HEADER */}
//       <div className="order-form-header">
//         <div className="order-form-header-top">
//           <div className="order-form-header-left">
//             <h1 className="order-form-title">
//               {isEditMode ? (
//                 <>
//                   <FiEdit3 className="title-icon" />
//                   Edit Order
//                   {initialOrder?.orderNumber && (
//                     <span className="order-number-badge">{initialOrder.orderNumber}</span>
//                   )}
//                 </>
//               ) : (
//                 <>
//                   <FiPlus className="title-icon" />
//                   Add Order
//                 </>
//               )}
//             </h1>

//             <div className="order-form-breadcrumbs">
//               <span className="breadcrumb-link">Dashboard</span>
//               <FiChevronRight className="breadcrumb-separator-icon" />
//               <button
//                 type="button"
//                 className="breadcrumb-link breadcrumb-button"
//                 onClick={onCancel}
//               >
//                 Order List
//               </button>
//               <FiChevronRight className="breadcrumb-separator-icon" />
//               <span className="breadcrumb-current">
//                 {isEditMode ? "Edit Order" : "Add Order"}
//               </span>
//             </div>
//           </div>

//           <div className="order-form-header-right">
//             <button
//               type="button"
//               className="btn btn-outline"
//               onClick={onCancel}
//               disabled={isLoading}
//             >
//               <FiX className="btn-icon" />
//               <span>Cancel</span>
//             </button>
//             <button
//               type="submit"
//               form="order-form"
//               className="btn btn-primary"
//               disabled={isLoading || items.length === 0 || !selectedCustomer}
//             >
//               <FiCheck className="btn-icon" />
//               <span>
//                 {isLoading 
//                   ? "Saving..." 
//                   : isEditMode 
//                     ? "Update Order" 
//                     : "Save Order"
//                 }
//               </span>
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* BODY */}
//       <form id="order-form" className="order-form-body" onSubmit={handleSubmit}>
//         {/* Edit Mode Banner */}
//         {isEditMode && (
//           <div className="edit-mode-banner">
//             <FiEdit3 className="edit-mode-icon" />
//             <div className="edit-mode-content">
//               <span className="edit-mode-title">Editing Order</span>
//               <span className="edit-mode-subtitle">
//                 You can modify products, quantities, or change the panchayat
//               </span>
//             </div>
//             <span className="edit-mode-items-count">
//               {items.length} item{items.length !== 1 ? 's' : ''} • {formatINR(grandTotal)}
//             </span>
//           </div>
//         )}

//         {/* Select Panchayat card */}
//         <div className="order-form-card">
//           <div className="card-title-row">
//             <h2 className="card-title">
//               Select Panchayat
//               {isEditMode && selectedCustomer && (
//                 <span className="card-title-badge">Current</span>
//               )}
//             </h2>
//             {selectedCustomer && (
//               <button
//                 type="button"
//                 className="btn btn-text btn-small"
//                 onClick={handleClearCustomer}
//               >
//                 <FiX size={14} />
//                 <span>Change Panchayat</span>
//               </button>
//             )}
//           </div>

//           <div className="order-search-row">
//             <div className="order-search-wrapper">
//               <FiSearch className="order-search-icon" />
//               <input
//                 ref={customerInputRef}
//                 type="text"
//                 className="order-search-input"
//                 placeholder="Search panchayat, taluk, or district..."
//                 value={customerQuery}
//                 onChange={(e) => {
//                   setCustomerQuery(e.target.value);
//                   setShowCustomerSuggestions(true);
//                   if (selectedCustomer && e.target.value !== selectedCustomer.name) {
//                     setSelectedCustomer(null);
//                   }
//                 }}
//                 onFocus={() => setShowCustomerSuggestions(true)}
//                 onBlur={handleCustomerBlur}
//                 onKeyDown={handleCustomerKeyDown}
//               />

//               {showCustomerSuggestions && customerSuggestions.length > 0 && (
//                 <div className="order-suggestions">
//                   {customerSuggestions.map((panchayat) => (
//                     <button
//                       key={`${panchayat.district}-${panchayat.taluk}-${panchayat.name}`}
//                       type="button"
//                       className={`suggestion-item ${
//                         selectedCustomer?.name === panchayat.name &&
//                         selectedCustomer?.taluk === panchayat.taluk &&
//                         selectedCustomer?.district === panchayat.district
//                           ? "selected"
//                           : ""
//                       }`}
//                       onMouseDown={(e) => {
//                         e.preventDefault();
//                         handleSelectCustomer(panchayat);
//                       }}
//                     >
//                       <div className="suggestion-icon">
//                         <FiMapPin />
//                       </div>
//                       <div className="suggestion-content">
//                         <div className="suggestion-main">{panchayat.name}</div>
//                         <div className="suggestion-sub">
//                           {panchayat.taluk}, {panchayat.district}
//                         </div>
//                       </div>
//                     </button>
//                   ))}
//                   {customerSuggestions.length >= 50 && (
//                     <div className="suggestion-item suggestion-info">
//                       <div className="suggestion-sub">
//                         Showing first 50 results. Use filters to narrow down.
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               )}
//               {showCustomerSuggestions &&
//                 customerSuggestions.length === 0 &&
//                 (customerQuery || hasActivePanchayatFilters) && (
//                   <div className="order-suggestions">
//                     <div className="suggestion-item no-results" style={{ cursor: "default" }}>
//                       <div className="suggestion-main">No panchayats found</div>
//                       <div className="suggestion-sub">
//                         Try a different search term or adjust filters
//                       </div>
//                     </div>
//                   </div>
//                 )}
//             </div>

//             <button
//               type="button"
//               className={`filters-btn ${showPanchayatFilters ? "active" : ""} ${
//                 hasActivePanchayatFilters ? "has-filters" : ""
//               }`}
//               onClick={() => setShowPanchayatFilters(!showPanchayatFilters)}
//             >
//               <FiFilter className="filters-icon" />
//               <span>Filters</span>
//               {activePanchayatFilterCount > 0 && (
//                 <span className="filter-count-badge">{activePanchayatFilterCount}</span>
//               )}
//             </button>
//           </div>

//           {/* Panchayat Filter Panel */}
//           {showPanchayatFilters && (
//             <div className="panchayat-filter-panel">
//               <div className="filter-panel-content">
//                 <div className="filter-group">
//                   <label className="filter-label">District</label>
//                   <select
//                     className="filter-select"
//                     value={districtFilter}
//                     onChange={(e) => setDistrictFilter(e.target.value)}
//                   >
//                     {districtOptions.map((option) => (
//                       <option key={option.value} value={option.value}>
//                         {option.label}
//                       </option>
//                     ))}
//                   </select>
//                 </div>

//                 <div className="filter-group">
//                   <label className="filter-label">Taluk</label>
//                   <select
//                     className="filter-select"
//                     value={talukFilter}
//                     onChange={(e) => setTalukFilter(e.target.value)}
//                   >
//                     {talukOptions.map((option) => (
//                       <option key={option.value} value={option.value}>
//                         {option.label}
//                       </option>
//                     ))}
//                   </select>
//                 </div>

//                 <div className="filter-actions">
//                   <button
//                     type="button"
//                     className="filter-clear-btn"
//                     onClick={handleClearPanchayatFilters}
//                     disabled={!hasActivePanchayatFilters}
//                   >
//                     Clear Filters
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* Panchayat Details Display */}
//           {selectedCustomer && (
//             <div className="customer-details panchayat-details">
//               <div className="panchayat-header-badge">
//                 <FiMapPin className="panchayat-badge-icon" />
//                 <span>Selected Panchayat</span>
//               </div>
//               <div className="customer-row">
//                 <div className="customer-col">
//                   <div className="customer-label">Panchayat Name</div>
//                   <div className="customer-value">{selectedCustomer.name}</div>
//                 </div>
//                 <div className="customer-col">
//                   <div className="customer-label">Taluk</div>
//                   <div className="customer-value">{selectedCustomer.taluk || "-"}</div>
//                 </div>
//                 <div className="customer-col">
//                   <div className="customer-label">District</div>
//                   <div className="customer-value">{selectedCustomer.district || "-"}</div>
//                 </div>
//               </div>
//               <div className="customer-row">
//                 <div className="customer-col">
//                   <div className="customer-label">E-mail Id</div>
//                   <div className="customer-value">{selectedCustomer.email || "-"}</div>
//                 </div>
//                 <div className="customer-col">
//                   <div className="customer-label">Contact Number</div>
//                   <div className="customer-value">{selectedCustomer.phone || "-"}</div>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>

//         {/* Add Products card */}
//         <div className="order-form-card">
//           <div className="card-title-row">
//             <h2 className="card-title">
//               {isEditMode ? "Order Products" : "Add Products"}
//               {items.length > 0 && (
//                 <span className="items-count-badge">{items.length} items</span>
//               )}
//             </h2>
//             {isEditMode && items.length > 0 && (
//               <span className="edit-hint">Add or remove products as needed</span>
//             )}
//           </div>

//           <div className="order-search-row">
//             <div className="order-search-wrapper">
//               <FiSearch className="order-search-icon" />
//               <input
//                 ref={productInputRef}
//                 type="text"
//                 className="order-search-input"
//                 placeholder="Search products by name or SKU to add..."
//                 value={productQuery}
//                 onChange={(e) => {
//                   setProductQuery(e.target.value);
//                   setShowProductSuggestions(true);
//                 }}
//                 onFocus={() => {
//                   setShowProductSuggestions(true);
//                   if (!productQuery) fetchProducts();
//                 }}
//                 onBlur={handleProductBlur}
//                 onKeyDown={handleProductKeyDown}
//               />
//               {loadingProducts && <FiLoader className="order-search-loading" />}

//               {showProductSuggestions && !loadingProducts && productSuggestions.length > 0 && (
//                 <div className="order-suggestions">
//                   {productSuggestions.map((product) => {
//                     const isAlreadyAdded = items.some(item => item.sku === product.sku);
//                     return (
//                       <button
//                         key={product.id}
//                         type="button"
//                         className={`suggestion-item ${isAlreadyAdded ? 'already-added' : ''}`}
//                         onMouseDown={(e) => {
//                           e.preventDefault();
//                           handleSelectProduct(product);
//                         }}
//                       >
//                         <div className="suggestion-main">
//                           {product.name}
//                           {isAlreadyAdded && <span className="added-badge">In cart</span>}
//                         </div>
//                         <div className="suggestion-sub">
//                           SKU: {product.sku} • {formatINR(product.price)}
//                         </div>
//                       </button>
//                     );
//                   })}
//                 </div>
//               )}
//               {showProductSuggestions &&
//                 !loadingProducts &&
//                 productSuggestions.length === 0 &&
//                 productQuery && (
//                   <div className="order-suggestions">
//                     <div className="suggestion-item no-results" style={{ cursor: "default" }}>
//                       <div className="suggestion-main">No products found</div>
//                       <div className="suggestion-sub">Try a different search term</div>
//                     </div>
//                   </div>
//                 )}
//             </div>

//             <button
//               type="button"
//               className="filters-btn"
//               onClick={() => console.log("Product filters clicked")}
//             >
//               <FiFilter className="filters-icon" />
//               <span>Filters</span>
//             </button>
//           </div>

//           {/* Products Table */}
//           <div className="orders-table-wrapper order-products-table-wrapper">
//             <table className="orders-table">
//               <thead>
//                 <tr>
//                   <th className="col-product">Product</th>
//                   <th className="col-sku">SKU</th>
//                   <th className="col-qty">QTY</th>
//                   <th className="col-total">Price</th>
//                   <th className="col-total">Total</th>
//                   <th className="col-delete" />
//                 </tr>
//               </thead>
//               <tbody>
//                 {items.length === 0 ? (
//                   <tr>
//                     <td colSpan={6} className="empty-table-cell">
//                       {isEditMode 
//                         ? "All products have been removed. Add products to update the order."
//                         : "No products added yet. Search above to add products."
//                       }
//                     </td>
//                   </tr>
//                 ) : (
//                   items.map((item) => (
//                     <tr key={item.lineId}>
//                       <td className="col-product">
//                         <div className="product-cell-content">
//                           {item.image && (
//                             <div className="product-thumbnail-small">
//                               <img src={item.image} alt={item.name} />
//                             </div>
//                           )}
//                           <div>
//                             <div className="product-main">{item.name}</div>
//                             {item.variant && (
//                               <div className="product-sub">{item.variant}</div>
//                             )}
//                           </div>
//                         </div>
//                       </td>
//                       <td className="col-sku">
//                         <span className="sku-text">{item.sku}</span>
//                       </td>
//                       <td className="col-qty">
//                         <input
//                           type="number"
//                           min={1}
//                           className="qty-input"
//                           value={item.qty}
//                           onChange={(e) => handleChangeQty(item.lineId, e.target.value)}
//                         />
//                       </td>
//                       <td className="col-total">{formatINR(item.price)}</td>
//                       <td className="col-total">{formatINR(item.price * item.qty)}</td>
//                       <td className="col-delete">
//                         <button
//                           type="button"
//                           className="icon-button small danger"
//                           title="Remove"
//                           onClick={() => handleRemoveItem(item.lineId)}
//                         >
//                           <FiTrash2 />
//                         </button>
//                       </td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//             </table>
//           </div>

//           {items.length > 0 && (
//             <div className="order-grand-total">
//               <span>Grand Total:</span>
//               <span className="order-grand-total-value">{formatINR(grandTotal)}</span>
//             </div>
//           )}

//           {displayError && (
//             <div className="order-form-error">{displayError}</div>
//           )}
//         </div>
//       </form>
//     </div>
//   );
// };

// export default OrderForm;

import React, { useMemo, useState, useEffect, useRef, useCallback } from "react";
import "./orderForm.css";
import {
  FiChevronRight,
  FiX,
  FiCheck,
  FiSearch,
  FiFilter,
  FiTrash2,
  FiLoader,
  FiMapPin,
  FiEdit3,
  FiPlus,
  FiRefreshCw,
} from "react-icons/fi";
import { 
  STATE_DISTRICTS, 
  DISTRICT_TALUKS, 
  TALUK_PANCHAYATS 
} from "../Customers/customerLocationData";

const API_BASE = process.env.REACT_APP_EP || "http://localhost:5000";

const inrFormatter = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  maximumFractionDigits: 2,
});
const formatINR = (value) => inrFormatter.format(value ?? 0);

// ✅ FIXED: Better mapping for initial items with proper price handling
const mapInitialItems = (items = [], productPriceMap = {}) => {
  if (!items || items.length === 0) return [];
  
  return items.map((item, index) => {
    // The price used in this order (could be negotiated)
    // Priority: unit_price > unitPrice > price (these are the saved order prices)
    const orderPrice = Number(
      item.unit_price || 
      item.unitPrice || 
      item.price || 
      0
    );
    
    // Original price from various sources
    // Priority: original_price > originalPrice > base_price > basePrice > from product map
    const savedOriginalPrice = Number(
      item.original_price || 
      item.originalPrice || 
      item.base_price || 
      item.basePrice || 
      0
    );
    
    // Get from product price map if available
    const productBasePrice = productPriceMap[item.sku];
    
    // Determine the original price to use
    let originalPrice;
    if (savedOriginalPrice > 0) {
      originalPrice = savedOriginalPrice;
    } else if (productBasePrice !== undefined && productBasePrice > 0) {
      originalPrice = Number(productBasePrice);
    } else {
      // Mark as needing fetch if no original price available
      originalPrice = null;
    }

    console.log(`Mapping item ${item.sku}:`, {
      orderPrice,
      savedOriginalPrice,
      productBasePrice,
      finalOriginalPrice: originalPrice
    });
    
    return {
      lineId: item.lineId || `${item.sku || item.id || "line"}-${index}-${Math.random().toString(36).slice(2, 7)}`,
      productId: item.productId || item.product_id || item.id,
      name: item.name || item.product_name || item.productName || "",
      sku: item.sku || "",
      price: orderPrice,
      originalPrice: originalPrice,
      qty: Number(item.qty || item.quantity || 1),
      image: item.image || item.image_url || item.imageUrl || null,
    };
  });
};

const OrderForm = ({
  initialOrder,
  preSelectedPanchayat,
  onCancel,
  onSave,
  loading: parentLoading,
  error: parentError,
}) => {
  const customerInputRef = useRef(null);
  const productInputRef = useRef(null);

  const isEditMode = Boolean(initialOrder?.id);

  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customerQuery, setCustomerQuery] = useState("");
  const [showCustomerSuggestions, setShowCustomerSuggestions] = useState(false);
  
  const [districtFilter, setDistrictFilter] = useState("all");
  const [talukFilter, setTalukFilter] = useState("all");
  const [showPanchayatFilters, setShowPanchayatFilters] = useState(false);

  const [products, setProducts] = useState([]);
  const [productPriceMap, setProductPriceMap] = useState({});
  const [productQuery, setProductQuery] = useState("");
  const [showProductSuggestions, setShowProductSuggestions] = useState(false);
  const [loadingProducts, setLoadingProducts] = useState(false);

  const [items, setItems] = useState([]);
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);
  const [originalPricesFetched, setOriginalPricesFetched] = useState(false);

  const allPanchayats = useMemo(() => {
    let panchayatList = [];
    let idCounter = 1;

    const districts = STATE_DISTRICTS["Karnataka"] || [];
    districts.forEach(district => {
      const taluks = DISTRICT_TALUKS[district] || [];
      taluks.forEach(taluk => {
        const panchayats = TALUK_PANCHAYATS[taluk] || [];
        panchayats.forEach(name => {
          panchayatList.push({
            id: idCounter++,
            name: name,
            taluk: taluk,
            district: district,
            phone: "",
          });
        });
      });
    });

    return panchayatList;
  }, []);

  const districtOptions = useMemo(() => {
    const districts = STATE_DISTRICTS["Karnataka"] || [];
    return [
      { value: "all", label: "All Districts" },
      ...districts.map(district => ({ value: district, label: district }))
    ];
  }, []);

  const talukOptions = useMemo(() => {
    if (districtFilter === "all") {
      const allTaluks = new Set();
      const districts = STATE_DISTRICTS["Karnataka"] || [];
      districts.forEach(district => {
        const taluks = DISTRICT_TALUKS[district] || [];
        taluks.forEach(taluk => allTaluks.add(taluk));
      });
      const sortedTaluks = Array.from(allTaluks).sort();
      return [
        { value: "all", label: "All Taluks" },
        ...sortedTaluks.map(taluk => ({ value: taluk, label: taluk }))
      ];
    } else {
      const taluks = DISTRICT_TALUKS[districtFilter] || [];
      return [
        { value: "all", label: "All Taluks" },
        ...taluks.map(taluk => ({ value: taluk, label: taluk }))
      ];
    }
  }, [districtFilter]);

  useEffect(() => {
    setTalukFilter("all");
  }, [districtFilter]);

  // Fetch products and build price map
  const fetchProducts = useCallback(async (search = "") => {
    setLoadingProducts(true);
    try {
      const params = search
        ? `?search=${encodeURIComponent(search)}`
        : "?limit=100";
      const response = await fetch(`${API_BASE}/api/products${params}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });

      if (!response.ok) throw new Error("Failed to fetch products");

      const data = await response.json();
      const productsList = data.data || data.products || [];

      const transformedProducts = productsList.map((p) => ({
        id: p.sku || p.id,
        sku: p.sku,
        name: p.product_name || p.name || "",
        price: Number(p.base_price || p.price || 0),
        stock: p.quantity || p.stock_quantity || 0,
        description: p.description || "",
        image: p.image_url || p.image || null,
      }));

      setProducts(transformedProducts);

      const newPriceMap = {};
      transformedProducts.forEach((p) => {
        if (p.sku) {
          newPriceMap[p.sku] = p.price;
        }
      });
      
      setProductPriceMap(prev => ({ ...prev, ...newPriceMap }));

      return transformedProducts;
    } catch (err) {
      console.error("Error fetching products:", err);
      return [];
    } finally {
      setLoadingProducts(false);
    }
  }, []);

  // Fetch original prices for specific SKUs
  const fetchOriginalPricesForItems = useCallback(async (skus) => {
    if (!skus || skus.length === 0) return {};

    try {
      const response = await fetch(`${API_BASE}/api/products?limit=500`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });

      if (!response.ok) throw new Error("Failed to fetch products");

      const data = await response.json();
      const productsList = data.data || data.products || [];

      const priceMap = {};
      productsList.forEach((p) => {
        const sku = p.sku;
        const basePrice = Number(p.base_price || p.price || 0);
        if (sku) {
          priceMap[sku] = basePrice;
        }
      });

      return priceMap;
    } catch (err) {
      console.error("Error fetching original prices:", err);
      return {};
    }
  }, []);

  // Initialize form
  useEffect(() => {
    if (isInitialized) return;

    console.log("Initializing OrderForm with:", { initialOrder, preSelectedPanchayat, isEditMode });

    if (isEditMode && initialOrder) {
      console.log("Loading existing order for editing:", initialOrder);

      if (initialOrder.items && initialOrder.items.length > 0) {
        const mappedItems = mapInitialItems(initialOrder.items, {});
        console.log("Mapped items for editing:", mappedItems);
        setItems(mappedItems);
      }

      if (initialOrder.customer || initialOrder.panchayat) {
        const customerData = initialOrder.customer || initialOrder.panchayat;
        
        const panchayatName = customerData.name || initialOrder.panchayat?.name;
        const panchayatTaluk = customerData.taluk || initialOrder.panchayat?.taluk || initialOrder.shippingAddress?.taluk;
        const panchayatDistrict = customerData.district || initialOrder.panchayat?.district || initialOrder.shippingAddress?.district;

        const matchingPanchayat = allPanchayats.find(
          (p) => 
            p.name === panchayatName && 
            (p.taluk === panchayatTaluk || !panchayatTaluk) && 
            (p.district === panchayatDistrict || !panchayatDistrict)
        );

        if (matchingPanchayat) {
          setSelectedCustomer(matchingPanchayat);
          setCustomerQuery(matchingPanchayat.name);
          setDistrictFilter(matchingPanchayat.district);
          setTimeout(() => setTalukFilter(matchingPanchayat.taluk), 0);
        } else {
          const customer = {
            id: customerData.id,
            name: panchayatName || "Unknown",
            email: customerData.email || "",
            phone: customerData.phone || "",
            taluk: panchayatTaluk || "",
            district: panchayatDistrict || "",
          };
          setSelectedCustomer(customer);
          setCustomerQuery(customer.name);
          if (panchayatDistrict) setDistrictFilter(panchayatDistrict);
          if (panchayatTaluk) setTimeout(() => setTalukFilter(panchayatTaluk), 0);
        }
      }

      setIsInitialized(true);
      return;
    }

    let panchayatToSelect = preSelectedPanchayat;
    
    if (!panchayatToSelect) {
      const storedPanchayat = sessionStorage.getItem("selectedPanchayat");
      if (storedPanchayat) {
        try {
          panchayatToSelect = JSON.parse(storedPanchayat);
          sessionStorage.removeItem("selectedPanchayat");
          sessionStorage.removeItem("orderAction");
        } catch (e) {
          console.error("Error parsing stored panchayat:", e);
        }
      }
    }

    if (panchayatToSelect) {
      const matchingPanchayat = allPanchayats.find(
        (p) => 
          p.name === panchayatToSelect.name && 
          p.taluk === panchayatToSelect.taluk && 
          p.district === panchayatToSelect.district
      );

      if (matchingPanchayat) {
        setSelectedCustomer(matchingPanchayat);
        setCustomerQuery(matchingPanchayat.name);
        setDistrictFilter(matchingPanchayat.district);
        setTimeout(() => setTalukFilter(matchingPanchayat.taluk), 0);
      } else {
        const newPanchayat = {
          id: Date.now(),
          name: panchayatToSelect.name,
          taluk: panchayatToSelect.taluk || "",
          district: panchayatToSelect.district || "",
          email: "",
          phone: "",
        };
        setSelectedCustomer(newPanchayat);
        setCustomerQuery(newPanchayat.name);
        if (panchayatToSelect.district) setDistrictFilter(panchayatToSelect.district);
        if (panchayatToSelect.taluk) setTimeout(() => setTalukFilter(panchayatToSelect.taluk), 0);
      }
    }

    setIsInitialized(true);
  }, [initialOrder, preSelectedPanchayat, allPanchayats, isEditMode, isInitialized]);

  // Fetch original prices for edit mode
  useEffect(() => {
    const updateOriginalPrices = async () => {
      if (!isEditMode || !isInitialized || originalPricesFetched || items.length === 0) {
        return;
      }

      console.log("Fetching original prices for edit mode...");

      const allSkus = items.map(item => item.sku).filter(Boolean);

      if (allSkus.length === 0) {
        setOriginalPricesFetched(true);
        return;
      }

      const priceMap = await fetchOriginalPricesForItems(allSkus);
      console.log("Fetched price map:", priceMap);

      setItems(prevItems => 
        prevItems.map(item => {
          const fetchedOriginalPrice = priceMap[item.sku];
          
          // Only update original price if it's null (not already set)
          let finalOriginalPrice = item.originalPrice;
          
          if (finalOriginalPrice === null || finalOriginalPrice === undefined || finalOriginalPrice === 0) {
            finalOriginalPrice = fetchedOriginalPrice !== undefined 
              ? fetchedOriginalPrice 
              : item.price;
          }

          console.log(`Updated item ${item.sku}: price=${item.price}, originalPrice=${finalOriginalPrice}`);

          return {
            ...item,
            originalPrice: finalOriginalPrice,
          };
        })
      );

      setProductPriceMap(prev => ({ ...prev, ...priceMap }));
      setOriginalPricesFetched(true);
    };

    updateOriginalPrices();
  }, [isEditMode, isInitialized, originalPricesFetched, items.length, fetchOriginalPricesForItems]);

  const customerSuggestions = useMemo(() => {
    let filtered = allPanchayats;

    if (districtFilter !== "all") {
      filtered = filtered.filter(p => p.district === districtFilter);
    }

    if (talukFilter !== "all") {
      filtered = filtered.filter(p => p.taluk === talukFilter);
    }

    if (customerQuery) {
      const query = customerQuery.toLowerCase();
      filtered = filtered.filter(
        (p) =>
          p.name.toLowerCase().includes(query) ||
          p.taluk.toLowerCase().includes(query) ||
          p.district.toLowerCase().includes(query)
      );
    }

    return filtered.slice(0, 50);
  }, [allPanchayats, customerQuery, districtFilter, talukFilter]);

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (productQuery) {
        fetchProducts(productQuery);
        setShowProductSuggestions(true);
      }
    }, 400);

    return () => clearTimeout(timer);
  }, [productQuery, fetchProducts]);

  const productSuggestions = products;

  // ✅ FIXED: Calculate grand total with proper handling of empty values
  const grandTotal = useMemo(() => {
    const total = items.reduce((sum, item) => {
      const price = item.price === "" || item.price === null || item.price === undefined 
        ? 0 
        : Number(item.price) || 0;
      const qty = item.qty === "" || item.qty === null || item.qty === undefined 
        ? 0 
        : Number(item.qty) || 0;
      return sum + (price * qty);
    }, 0);
    
    console.log("Calculated grandTotal:", total, "from items:", items.map(i => ({ sku: i.sku, price: i.price, qty: i.qty })));
    return total;
  }, [items]);

  const handleCustomerKeyDown = (e) => {
    if (e.key === "Enter") e.preventDefault();
    if (e.key === "Escape") setShowCustomerSuggestions(false);
  };

  const handleProductKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (productQuery) fetchProducts(productQuery);
    }
    if (e.key === "Escape") setShowProductSuggestions(false);
  };

  const handleCustomerBlur = (e) => {
    const wrapper = e.currentTarget.closest(".order-search-wrapper");
    if (wrapper && wrapper.contains(e.relatedTarget)) return;
    setTimeout(() => setShowCustomerSuggestions(false), 200);
  };

  const handleProductBlur = (e) => {
    const wrapper = e.currentTarget.closest(".order-search-wrapper");
    if (wrapper && wrapper.contains(e.relatedTarget)) return;
    setTimeout(() => setShowProductSuggestions(false), 200);
  };

  const handleSelectCustomer = (customer) => {
    setSelectedCustomer(customer);
    setCustomerQuery(customer.name);
    setShowCustomerSuggestions(false);
    setShowPanchayatFilters(false);
  };

  const handleSelectProduct = (product) => {
    const existingIndex = items.findIndex(item => item.sku === product.sku);
    
    if (existingIndex >= 0) {
      setItems(prev => prev.map((item, index) => 
        index === existingIndex 
          ? { ...item, qty: (Number(item.qty) || 0) + 1 }
          : item
      ));
    } else {
      setItems((prev) => [
        ...prev,
        {
          lineId: `${product.id}-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
          productId: product.id,
          name: product.name,
          sku: product.sku,
          price: product.price,
          originalPrice: product.price,
          qty: 1,
          image: product.image,
        },
      ]);

      if (product.sku) {
        setProductPriceMap(prev => ({ ...prev, [product.sku]: product.price }));
      }
    }
    
    setProductQuery("");
    setShowProductSuggestions(false);
    setTimeout(() => productInputRef.current?.focus(), 0);
  };

  const handleClearCustomer = () => {
    setSelectedCustomer(null);
    setCustomerQuery("");
    setDistrictFilter("all");
    setTalukFilter("all");
    setShowCustomerSuggestions(false);
    setTimeout(() => customerInputRef.current?.focus(), 0);
  };

  const handleClearPanchayatFilters = () => {
    setDistrictFilter("all");
    setTalukFilter("all");
  };

  const handleChangeQty = (lineId, raw) => {
    if (raw === "" || raw === null || raw === undefined) {
      setItems((prev) =>
        prev.map((item) => (item.lineId === lineId ? { ...item, qty: "" } : item))
      );
      return;
    }
    
    const value = Number(raw);
    if (Number.isFinite(value) && value >= 0) {
      setItems((prev) =>
        prev.map((item) => (item.lineId === lineId ? { ...item, qty: value } : item))
      );
    }
  };

  const handleQtyBlur = (lineId) => {
    setItems((prev) =>
      prev.map((item) => {
        if (item.lineId === lineId) {
          const qty = item.qty === "" || Number(item.qty) < 1 ? 1 : Number(item.qty);
          return { ...item, qty };
        }
        return item;
      })
    );
  };

  const handleChangePrice = (lineId, raw) => {
    if (raw === "" || raw === null || raw === undefined) {
      setItems((prev) =>
        prev.map((item) => (item.lineId === lineId ? { ...item, price: "" } : item))
      );
      return;
    }
    
    const value = Number(raw);
    if (Number.isFinite(value) && value >= 0) {
      setItems((prev) =>
        prev.map((item) => (item.lineId === lineId ? { ...item, price: value } : item))
      );
    }
  };

  const handlePriceBlur = (lineId) => {
    setItems((prev) =>
      prev.map((item) => {
        if (item.lineId === lineId) {
          if (item.price === "" || Number(item.price) < 0) {
            return { ...item, price: item.originalPrice || 0 };
          }
          return { ...item, price: Number(item.price) };
        }
        return item;
      })
    );
  };

  const handleResetPrice = (lineId) => {
    setItems((prev) =>
      prev.map((item) => {
        if (item.lineId === lineId && item.originalPrice !== null && item.originalPrice !== undefined) {
          return { ...item, price: item.originalPrice };
        }
        return item;
      })
    );
  };

  const handleRefreshOriginalPrices = async () => {
    if (items.length === 0) return;

    const skus = items.map(item => item.sku).filter(Boolean);
    const priceMap = await fetchOriginalPricesForItems(skus);

    setItems(prevItems =>
      prevItems.map(item => {
        const newOriginalPrice = priceMap[item.sku];
        if (newOriginalPrice !== undefined) {
          return { ...item, originalPrice: newOriginalPrice };
        }
        return item;
      })
    );

    setProductPriceMap(prev => ({ ...prev, ...priceMap }));
  };

  const handleRemoveItem = (lineId) => {
    setItems((prev) => prev.filter((item) => item.lineId !== lineId));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedCustomer) {
      setError("Please select a panchayat.");
      return;
    }
    if (!items.length) {
      setError("Please add at least one product.");
      return;
    }

    const hasInvalidItems = items.some(item => 
      item.qty === "" || Number(item.qty) < 1 || 
      item.price === "" || Number(item.price) < 0
    );

    if (hasInvalidItems) {
      setError("Please ensure all quantities are at least 1 and prices are valid.");
      return;
    }

    setError("");
    setSaving(true);

    try {
      // ✅ IMPORTANT: Make sure to send the correct prices
      const itemsForSave = items.map(({ lineId, ...rest }) => ({
        sku: rest.sku,
        quantity: Number(rest.qty),
        unit_price: Number(rest.price),  // This is the negotiated price
        original_price: rest.originalPrice || Number(rest.price), // Original for reference
        product_id: rest.productId,
        name: rest.name,
      }));

      // ✅ Calculate total from the items we're saving
      const calculatedTotal = itemsForSave.reduce(
        (sum, item) => sum + (item.unit_price * item.quantity), 
        0
      );

      const orderData = {
        id: initialOrder?.id || null,
        panchayat_name: selectedCustomer.name,
        panchayat_taluk: selectedCustomer.taluk,
        panchayat_district: selectedCustomer.district,
        panchayat_state: 'Karnataka',
        customer_name: selectedCustomer.name,
        customer_taluk: selectedCustomer.taluk,
        customer_district: selectedCustomer.district,
        customer: selectedCustomer,
        panchayat: {
          name: selectedCustomer.name,
          taluk: selectedCustomer.taluk,
          district: selectedCustomer.district,
        },
        items: itemsForSave,
        total_amount: calculatedTotal, // ✅ Use calculated total
        shipping_address: {
          panchayat: selectedCustomer.name,
          taluk: selectedCustomer.taluk,
          district: selectedCustomer.district,
          state: 'Karnataka'
        }
      };

      console.log("Submitting order:", orderData);
      console.log("Items with prices:", itemsForSave);
      console.log("Total amount:", calculatedTotal);
      
      await onSave(orderData);
    } catch (err) {
      setError(err.message || "Failed to save order");
    } finally {
      setSaving(false);
    }
  };

  const isLoading = saving || parentLoading;
  const displayError = error || parentError;

  const hasActivePanchayatFilters = districtFilter !== "all" || talukFilter !== "all";
  const activePanchayatFilterCount = [
    districtFilter !== "all",
    talukFilter !== "all"
  ].filter(Boolean).length;

  const hasModifiedPrices = items.some(item => 
    item.originalPrice !== null && 
    item.originalPrice !== undefined && 
    Number(item.price) !== Number(item.originalPrice)
  );

  const pricesLoading = isEditMode && !originalPricesFetched && items.length > 0;

  return (
    <div className="orders-page order-form-page">
      {/* HEADER */}
      <div className="order-form-header">
        <div className="order-form-header-top">
          <div className="order-form-header-left">
            <h1 className="order-form-title">
              {isEditMode ? (
                <>
                  <FiEdit3 className="title-icon" />
                  Edit Order
                  {initialOrder?.orderNumber && (
                    <span className="order-number-badge">{initialOrder.orderNumber}</span>
                  )}
                </>
              ) : (
                <>
                  <FiPlus className="title-icon" />
                  Add Order
                </>
              )}
            </h1>

            <div className="order-form-breadcrumbs">
              <span className="breadcrumb-link">Dashboard</span>
              <FiChevronRight className="breadcrumb-separator-icon" />
              <button
                type="button"
                className="breadcrumb-link breadcrumb-button"
                onClick={onCancel}
              >
                Order List
              </button>
              <FiChevronRight className="breadcrumb-separator-icon" />
              <span className="breadcrumb-current">
                {isEditMode ? "Edit Order" : "Add Order"}
              </span>
            </div>
          </div>

          <div className="order-form-header-right">
            <button
              type="button"
              className="btn btn-outline"
              onClick={onCancel}
              disabled={isLoading}
            >
              <FiX className="btn-icon" />
              <span>Cancel</span>
            </button>
            <button
              type="submit"
              form="order-form"
              className="btn btn-primary"
              disabled={isLoading || items.length === 0 || !selectedCustomer}
            >
              <FiCheck className="btn-icon" />
              <span>
                {isLoading 
                  ? "Saving..." 
                  : isEditMode 
                    ? "Update Order" 
                    : "Save Order"
                }
              </span>
            </button>
          </div>
        </div>
      </div>

      {/* BODY */}
      <form id="order-form" className="order-form-body" onSubmit={handleSubmit}>
        {/* Edit Mode Banner */}
        {isEditMode && (
          <div className="edit-mode-banner">
            <FiEdit3 className="edit-mode-icon" />
            <div className="edit-mode-content">
              <span className="edit-mode-title">Editing Order</span>
              <span className="edit-mode-subtitle">
                You can modify products, quantities, prices, or change the panchayat
              </span>
            </div>
            <span className="edit-mode-items-count">
              {items.length} item{items.length !== 1 ? 's' : ''} • {formatINR(grandTotal)}
            </span>
          </div>
        )}

        {/* Select Panchayat card */}
        <div className="order-form-card">
          <div className="card-title-row">
            <h2 className="card-title">
              Select Panchayat
              {isEditMode && selectedCustomer && (
                <span className="card-title-badge">Current</span>
              )}
            </h2>
            {selectedCustomer && (
              <button
                type="button"
                className="btn btn-text btn-small"
                onClick={handleClearCustomer}
              >
                <FiX size={14} />
                <span>Change Panchayat</span>
              </button>
            )}
          </div>

          <div className="order-search-row">
            <div className="order-search-wrapper">
              <FiSearch className="order-search-icon" />
              <input
                ref={customerInputRef}
                type="text"
                className="order-search-input"
                placeholder="Search panchayat, taluk, or district..."
                value={customerQuery}
                onChange={(e) => {
                  setCustomerQuery(e.target.value);
                  setShowCustomerSuggestions(true);
                  if (selectedCustomer && e.target.value !== selectedCustomer.name) {
                    setSelectedCustomer(null);
                  }
                }}
                onFocus={() => setShowCustomerSuggestions(true)}
                onBlur={handleCustomerBlur}
                onKeyDown={handleCustomerKeyDown}
              />

              {showCustomerSuggestions && customerSuggestions.length > 0 && (
                <div className="order-suggestions">
                  {customerSuggestions.map((panchayat) => (
                    <button
                      key={`${panchayat.district}-${panchayat.taluk}-${panchayat.name}`}
                      type="button"
                      className={`suggestion-item ${
                        selectedCustomer?.name === panchayat.name &&
                        selectedCustomer?.taluk === panchayat.taluk &&
                        selectedCustomer?.district === panchayat.district
                          ? "selected"
                          : ""
                      }`}
                      onMouseDown={(e) => {
                        e.preventDefault();
                        handleSelectCustomer(panchayat);
                      }}
                    >
                      <div className="suggestion-icon">
                        <FiMapPin />
                      </div>
                      <div className="suggestion-content">
                        <div className="suggestion-main">{panchayat.name}</div>
                        <div className="suggestion-sub">
                          {panchayat.taluk}, {panchayat.district}
                        </div>
                      </div>
                    </button>
                  ))}
                  {customerSuggestions.length >= 50 && (
                    <div className="suggestion-item suggestion-info">
                      <div className="suggestion-sub">
                        Showing first 50 results. Use filters to narrow down.
                      </div>
                    </div>
                  )}
                </div>
              )}
              {showCustomerSuggestions &&
                customerSuggestions.length === 0 &&
                (customerQuery || hasActivePanchayatFilters) && (
                  <div className="order-suggestions">
                    <div className="suggestion-item no-results" style={{ cursor: "default" }}>
                      <div className="suggestion-main">No panchayats found</div>
                      <div className="suggestion-sub">
                        Try a different search term or adjust filters
                      </div>
                    </div>
                  </div>
                )}
            </div>

            <button
              type="button"
              className={`filters-btn ${showPanchayatFilters ? "active" : ""} ${
                hasActivePanchayatFilters ? "has-filters" : ""
              }`}
              onClick={() => setShowPanchayatFilters(!showPanchayatFilters)}
            >
              <FiFilter className="filters-icon" />
              <span>Filters</span>
              {activePanchayatFilterCount > 0 && (
                <span className="filter-count-badge">{activePanchayatFilterCount}</span>
              )}
            </button>
          </div>

          {showPanchayatFilters && (
            <div className="panchayat-filter-panel">
              <div className="filter-panel-content">
                <div className="filter-group">
                  <label className="filter-label">District</label>
                  <select
                    className="filter-select"
                    value={districtFilter}
                    onChange={(e) => setDistrictFilter(e.target.value)}
                  >
                    {districtOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="filter-group">
                  <label className="filter-label">Taluk</label>
                  <select
                    className="filter-select"
                    value={talukFilter}
                    onChange={(e) => setTalukFilter(e.target.value)}
                  >
                    {talukOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="filter-actions">
                  <button
                    type="button"
                    className="filter-clear-btn"
                    onClick={handleClearPanchayatFilters}
                    disabled={!hasActivePanchayatFilters}
                  >
                    Clear Filters
                  </button>
                </div>
              </div>
            </div>
          )}

          {selectedCustomer && (
            <div className="customer-details panchayat-details">
              <div className="panchayat-header-badge">
                <FiMapPin className="panchayat-badge-icon" />
                <span>Selected Panchayat</span>
              </div>
              <div className="customer-row">
                <div className="customer-col">
                  <div className="customer-label">Panchayat Name</div>
                  <div className="customer-value">{selectedCustomer.name}</div>
                </div>
                <div className="customer-col">
                  <div className="customer-label">Taluk</div>
                  <div className="customer-value">{selectedCustomer.taluk || "-"}</div>
                </div>
                <div className="customer-col">
                  <div className="customer-label">District</div>
                  <div className="customer-value">{selectedCustomer.district || "-"}</div>
                </div>
              </div>
              <div className="customer-row">
                <div className="customer-col">
                  <div className="customer-label">E-mail Id</div>
                  <div className="customer-value">{selectedCustomer.email || "-"}</div>
                </div>
                <div className="customer-col">
                  <div className="customer-label">Contact Number</div>
                  <div className="customer-value">{selectedCustomer.phone || "-"}</div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Add Products card */}
        <div className="order-form-card">
          <div className="card-title-row">
            <h2 className="card-title">
              {isEditMode ? "Order Products" : "Add Products"}
              {items.length > 0 && (
                <span className="items-count-badge">{items.length} items</span>
              )}
            </h2>
            <div className="card-title-right">
              {pricesLoading && (
                <span className="loading-prices-hint">
                  <FiLoader className="spin" /> Loading prices...
                </span>
              )}
              {hasModifiedPrices && (
                <span className="modified-prices-hint">
                  * Some prices have been modified
                </span>
              )}
              {isEditMode && items.length > 0 && !pricesLoading && (
                <button
                  type="button"
                  className="btn btn-text btn-small"
                  onClick={handleRefreshOriginalPrices}
                  title="Refresh original prices from product catalog"
                >
                  <FiRefreshCw size={14} />
                  <span>Refresh Prices</span>
                </button>
              )}
            </div>
          </div>

          <div className="order-search-row">
            <div className="order-search-wrapper">
              <FiSearch className="order-search-icon" />
              <input
                ref={productInputRef}
                type="text"
                className="order-search-input"
                placeholder="Search products by name or SKU to add..."
                value={productQuery}
                onChange={(e) => {
                  setProductQuery(e.target.value);
                  setShowProductSuggestions(true);
                }}
                onFocus={() => {
                  setShowProductSuggestions(true);
                  if (!productQuery) fetchProducts();
                }}
                onBlur={handleProductBlur}
                onKeyDown={handleProductKeyDown}
              />
              {loadingProducts && <FiLoader className="order-search-loading" />}

              {showProductSuggestions && !loadingProducts && productSuggestions.length > 0 && (
                <div className="order-suggestions">
                  {productSuggestions.map((product) => {
                    const isAlreadyAdded = items.some(item => item.sku === product.sku);
                    return (
                      <button
                        key={product.id}
                        type="button"
                        className={`suggestion-item ${isAlreadyAdded ? 'already-added' : ''}`}
                        onMouseDown={(e) => {
                          e.preventDefault();
                          handleSelectProduct(product);
                        }}
                      >
                        <div className="suggestion-main">
                          {product.name}
                          {isAlreadyAdded && <span className="added-badge">In cart</span>}
                        </div>
                        <div className="suggestion-sub">
                          SKU: {product.sku} • {formatINR(product.price)}
                        </div>
                      </button>
                    );
                  })}
                </div>
              )}
              {showProductSuggestions &&
                !loadingProducts &&
                productSuggestions.length === 0 &&
                productQuery && (
                  <div className="order-suggestions">
                    <div className="suggestion-item no-results" style={{ cursor: "default" }}>
                      <div className="suggestion-main">No products found</div>
                      <div className="suggestion-sub">Try a different search term</div>
                    </div>
                  </div>
                )}
            </div>

            <button
              type="button"
              className="filters-btn"
              onClick={() => console.log("Product filters clicked")}
            >
              <FiFilter className="filters-icon" />
              <span>Filters</span>
            </button>
          </div>

         

          {/* Products Table */}
          <div className="orders-table-wrapper order-products-table-wrapper">
            <table className="orders-table">
              <thead>
                <tr>
                  <th className="col-product">Product</th>
                  <th className="col-sku">SKU</th>
                  <th className="col-qty">QTY</th>
                  <th className="col-price">Price</th>
                  <th className="col-total">Total</th>
                  <th className="col-delete" />
                </tr>
              </thead>
              <tbody>
                {items.length === 0 ? (
                  <tr>
                    <td colSpan={6} className="empty-table-cell">
                      {isEditMode 
                        ? "All products have been removed. Add products to update the order."
                        : "No products added yet. Search above to add products."
                      }
                    </td>
                  </tr>
                ) : (
                  items.map((item) => {
                    const hasOriginalPrice = item.originalPrice !== null && item.originalPrice !== undefined;
                    const isPriceModified = hasOriginalPrice && 
                      Number(item.price) !== Number(item.originalPrice);
                    
                    const currentQty = item.qty === "" ? "" : item.qty;
                    const currentPrice = item.price === "" ? "" : item.price;
                    const displayTotal = (Number(item.price) || 0) * (Number(item.qty) || 0);
                    
                    return (
                      <tr key={item.lineId}>
                        <td className="col-product">
                          <div className="product-cell-content">
                            {item.image && (
                              <div className="product-thumbnail-small">
                                <img src={item.image} alt={item.name} />
                              </div>
                            )}
                            <div>
                              <div className="product-main">{item.name}</div>
                              {item.variant && (
                                <div className="product-sub">{item.variant}</div>
                              )}
                            </div>
                          </div>
                        </td>
                        <td className="col-sku">
                          <span className="sku-text">{item.sku}</span>
                        </td>
                        <td className="col-qty">
                          <input
                            type="number"
                            min={0}
                            step={1}
                            className="qty-input"
                            value={currentQty}
                            onChange={(e) => handleChangeQty(item.lineId, e.target.value)}
                            onBlur={() => handleQtyBlur(item.lineId)}
                            placeholder="1"
                          />
                        </td>
                        <td className="col-price">
                          <div className="price-input-wrapper">
                            <span className="price-currency">₹</span>
                            <input
                              type="number"
                              min={0}
                              step={0.01}
                              className={`price-input ${isPriceModified ? 'price-modified' : ''}`}
                              value={currentPrice}
                              onChange={(e) => handleChangePrice(item.lineId, e.target.value)}
                              onBlur={() => handlePriceBlur(item.lineId)}
                              placeholder={hasOriginalPrice ? item.originalPrice.toString() : "0"}
                            />
                            {isPriceModified && (
                              <button
                                type="button"
                                className="reset-price-btn"
                                onClick={() => handleResetPrice(item.lineId)}
                                title={`Reset to original price: ${formatINR(item.originalPrice)}`}
                              >
                                ↩
                              </button>
                            )}
                          </div>
                          {isPriceModified && (
                            <div className="original-price-hint">
                              Original: {formatINR(item.originalPrice)}
                            </div>
                          )}
                          {!hasOriginalPrice && pricesLoading && (
                            <div className="original-price-hint loading">
                              Loading original price...
                            </div>
                          )}
                        </td>
                        <td className="col-total">{formatINR(displayTotal)}</td>
                        <td className="col-delete">
                          <button
                            type="button"
                            className="icon-button small danger"
                            title="Remove"
                            onClick={() => handleRemoveItem(item.lineId)}
                          >
                            <FiTrash2 />
                          </button>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

          {items.length > 0 && (
            <div className="order-grand-total">
              <span>Grand Total:</span>
              <span className="order-grand-total-value">{formatINR(grandTotal)}</span>
            </div>
          )}

          {displayError && (
            <div className="order-form-error">{displayError}</div>
          )}
        </div>
      </form>
    </div>
  );
};

export default OrderForm;